import React from 'react';
import { Link } from 'react-router-dom';

const WhyUs = () => {
  const comparison = [
    { feature: 'Search & Viability', classic: 'May be separately scoped', tmrush: 'Basic screening included; expanded opinion by quote' },
    { feature: 'Pricing Model', classic: 'Pricing varies by provider', tmrush: 'Scope-defined fixed professional fees' },
    { feature: 'Filing Speed', classic: 'Timing varies', tmrush: '24 business-hour target after cleared payment and documents' },
    { feature: 'Third-Party Watch', classic: 'Varies by provider', tmrush: '12 months of Brazil Trademark Watch included with every filing' },
    { feature: 'Workflow', classic: 'Varies by provider', tmrush: 'Electronic BPTO filing and structured reporting' },
    { feature: 'Communication', classic: 'Varies by provider', tmrush: 'Direct "Partner-to-Partner" Support' },
    { feature: 'Success Rate', classic: 'Variable, depending on initial vetting', tmrush: 'Risk-led filing recommendations; no grant guarantee' },
    { feature: 'Market Authority', classic: 'Varies by provider', tmrush: 'Powered by Marcas Já (14,000+ Trademarks Filed)' },
  ];

  return (
    <section id="why-tm-rush" className="py-20 bg-background-auxiliary scroll-mt-24 relative">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-text mb-4">
            Why TM RUSH®
          </h2>
          <p className="text-xl text-text/70">
            How TM RUSH structures Brazilian trademark work for foreign counsel and global brands.
          </p>
        </div>

        {/* Desktop Table */}
        <div className="hidden md:block overflow-x-auto bg-white/70 rounded-2xl shadow-sm border border-gray-100/40">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-white/90">
                <th className="border border-gray-300 px-6 py-4 text-left font-semibold text-text">
                  Feature
                </th>
                <th className="border border-gray-300 px-6 py-4 text-center font-semibold text-gray-700">
                  Traditional Law Firms
                </th>
                <th className="border border-gray-200 px-6 py-5 text-center font-semibold text-primary">
                  TM RUSH®
                </th>
              </tr>
            </thead>
            <tbody>
              {comparison.map((row, index) => (
                <tr key={index} className={index % 2 === 0 ? 'bg-background-auxiliary/35' : 'bg-white/50'}>
                  <td className="border border-gray-200 px-6 py-5 font-semibold text-text">
                    {row.feature}
                  </td>
                  <td className="border border-gray-200 px-6 py-5 text-center text-text/70">
                    {row.classic}
                  </td>
                  <td className="border border-gray-200 px-6 py-5 text-center text-primary font-bold">
                    {row.tmrush}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile Cards */}
        <div className="md:hidden space-y-4">
          {comparison.map((row, index) => (
            <div key={index} className="bg-white/70 rounded-lg shadow-sm p-6 border border-gray-100/40 border-l-4 border-l-primary">
              <h4 className="font-semibold text-text mb-4">{row.feature}</h4>
              <div className="space-y-3">
                <div>
                  <p className="text-sm text-text/60 mb-1">Traditional Law Firms</p>
                  <p className="text-text/80">{row.classic}</p>
                </div>
                <div>
                  <p className="text-sm text-primary font-semibold mb-1">TM RUSH®</p>
                  <p className="text-primary font-semibold">{row.tmrush}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/order"
            className="inline-block bg-primary text-white px-10 py-4 rounded-xl hover:bg-primary-hover font-semibold shadow-md hover:shadow-lg"
          >
            Start Application
          </Link>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
